module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--4-42daefe9ae74895d241a412863a78f77.jpg";